/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { SCIMConfigurationRead } from '../models/SCIMConfigurationRead';
import type { SCIMConfigurationUpdate } from '../models/SCIMConfigurationUpdate';
import type { SCIMTokenAction } from '../models/SCIMTokenAction';
import type { SCIMTokenCreateResponse } from '../models/SCIMTokenCreateResponse';
import type { SCIMTokenRead } from '../models/SCIMTokenRead';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ScimService {
  /**
   * @param firmId
   * @returns SCIMConfigurationRead
   * @throws ApiError
   */
  public static apiScimConfigurationFirmRead(
    firmId: string,
  ): CancelablePromise<SCIMConfigurationRead> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/scim/configuration/firm/{firm_id}',
      path: {
        'firm_id': firmId,
      },
    });
  }
  /**
   * Create a new SCIM token for the given configuration. Maximum of two active tokens per configuration. If there are already two active tokens, the request will be rejected.
   * @param data
   * @returns SCIMTokenCreateResponse
   * @throws ApiError
   */
  public static apiScimConfigurationTokensCreate(
    data: {
      /**
       * ID of the SCIM configuration to create the token for
       */
      scim_configuration?: number;
    },
  ): CancelablePromise<SCIMTokenCreateResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/scim/configuration/tokens',
      body: data,
    });
  }
  /**
   * Revoke an active SCIM token. The token will be revoked immediately and cannot be used anymore. The revoked token will be returned in the response.
   * @param data
   * @returns SCIMTokenRead
   * @throws ApiError
   */
  public static apiScimConfigurationTokensRevokationCreate(
    data: SCIMTokenAction,
  ): CancelablePromise<SCIMTokenRead> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/scim/configuration/tokens/revokation',
      body: data,
    });
  }
  /**
   * Rotate an active SCIM token. The old token will be revoked and a new token will be created. The new token will be returned in the response.
   * @param data
   * @returns SCIMTokenCreateResponse
   * @throws ApiError
   */
  public static apiScimConfigurationTokensRotationCreate(
    data: SCIMTokenAction,
  ): CancelablePromise<SCIMTokenCreateResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/scim/configuration/tokens/rotation',
      body: data,
    });
  }
  /**
   * Update the SCIM configuration for the firm. Only one configuration can exist per firm.
   * @param configurationId
   * @param data
   * @returns SCIMConfigurationRead
   * @throws ApiError
   */
  public static apiScimConfigurationUpdate(
    configurationId: string,
    data: SCIMConfigurationUpdate,
  ): CancelablePromise<SCIMConfigurationRead> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/scim/configuration/{configuration_id}',
      path: {
        'configuration_id': configurationId,
      },
      body: data,
    });
  }
  /**
   * @param configurationId
   * @returns any
   * @throws ApiError
   */
  public static apiScimConfigurationPartialUpdate(
    configurationId: string,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/scim/configuration/{configuration_id}',
      path: {
        'configuration_id': configurationId,
      },
    });
  }
  /**
   * @param configurationId
   * @param page A page number within the paginated result set.
   * @returns any
   * @throws ApiError
   */
  public static apiScimConfigurationTokensList(
    configurationId: string,
    page?: number,
  ): CancelablePromise<{
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<SCIMTokenRead>;
  }> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/scim/configuration/{configuration_id}/tokens',
      path: {
        'configuration_id': configurationId,
      },
      query: {
        'page': page,
      },
    });
  }
  /**
   * @returns any
   * @throws ApiError
   */
  public static scimV2GroupsList(): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/scim/v2/Groups',
    });
  }
  /**
   * @param groupId
   * @returns any
   * @throws ApiError
   */
  public static scimV2GroupsRead(
    groupId: string,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/scim/v2/Groups/{group_id}',
      path: {
        'group_id': groupId,
      },
    });
  }
  /**
   * @param groupId
   * @returns any
   * @throws ApiError
   */
  public static scimV2GroupsUpdate(
    groupId: string,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/scim/v2/Groups/{group_id}',
      path: {
        'group_id': groupId,
      },
    });
  }
  /**
   * Handle PATCH requests to modify group membership.
   * Supports operations:
   * - add: Add members to the group
   * - remove: Remove members from the group
   * - replace: Replace all members with a new set
   * @param groupId
   * @returns any
   * @throws ApiError
   */
  public static scimV2GroupsPartialUpdate(
    groupId: string,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/scim/v2/Groups/{group_id}',
      path: {
        'group_id': groupId,
      },
    });
  }
  /**
   * @param groupId
   * @returns void
   * @throws ApiError
   */
  public static scimV2GroupsDelete(
    groupId: string,
  ): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/scim/v2/Groups/{group_id}',
      path: {
        'group_id': groupId,
      },
    });
  }
  /**
   * @returns any
   * @throws ApiError
   */
  public static scimV2ResourceTypesList(): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/scim/v2/ResourceTypes',
    });
  }
  /**
   * @returns any
   * @throws ApiError
   */
  public static scimV2SchemasList(): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/scim/v2/Schemas',
    });
  }
  /**
   * @returns any
   * @throws ApiError
   */
  public static scimV2ServiceProviderConfigList(): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/scim/v2/ServiceProviderConfig',
    });
  }
  /**
   * @returns any
   * @throws ApiError
   */
  public static scimV2UsersList(): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/scim/v2/Users',
    });
  }
  /**
   * @returns any
   * @throws ApiError
   */
  public static scimV2UsersCreate(): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/scim/v2/Users',
    });
  }
  /**
   * @param userId
   * @returns any
   * @throws ApiError
   */
  public static scimV2UsersRead(
    userId: string,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/scim/v2/Users/{user_id}',
      path: {
        'user_id': userId,
      },
    });
  }
  /**
   * @param userId
   * @returns any
   * @throws ApiError
   */
  public static scimV2UsersUpdate(
    userId: string,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/scim/v2/Users/{user_id}',
      path: {
        'user_id': userId,
      },
    });
  }
  /**
   * @param userId
   * @returns any
   * @throws ApiError
   */
  public static scimV2UsersPartialUpdate(
    userId: string,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/scim/v2/Users/{user_id}',
      path: {
        'user_id': userId,
      },
    });
  }
  /**
   * @param userId
   * @returns void
   * @throws ApiError
   */
  public static scimV2UsersDelete(
    userId: string,
  ): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/scim/v2/Users/{user_id}',
      path: {
        'user_id': userId,
      },
    });
  }
}
